
<div class="upload-sign-initials__container">
    <div class="upload-sign-initials__top">
        <canvas #canvas hidden></canvas>
        <div class="initials-label">{{ t('initialsLabel') }}</div>
        <mat-form-field appearance="outline" class="input-initials extra-small-input">
            <input matInput [placeholder]="t('initialsPlaceholder')" [formControl]="initialsCtrl" autocomplete
                [value]="initialsCtrl.value" />
            <mat-error>
                @if(initialsCtrl.errors?.['minlength']) {
                {{ t('minError') }}
                } @else {
                {{Messages.MSG_ERROR_REQUIRED}}
                }
            </mat-error>
            <mat-hint>{{ t('hint') }}</mat-hint>
        </mat-form-field>
    </div>
    <div class="upload-sign-initials__bottom">
        <div class="signature-text-label">{{ t('selectSignature') }}</div>
        <mat-radio-group class="image-initials__container" [formControl]="initialImgCtrl"
            (change)="initialImageChange()">
            @for(initial of initials; track initial.fontFamily; let index = $index) {
            <mat-card class="mat-elevation-z8 image-initial__container">
                <mat-radio-button [value]="initial.fontFamily" color="primary">
                    <img class="image-initial" [src]="initial.image" />
                </mat-radio-button>
            </mat-card>
            }
        </mat-radio-group>
    </div>
</div>